import { CommonModule } from '@angular/common';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { SharedModule } from 'src/app/components/shared/shared.module';
import { SharedReportsModule } from '../../shared/shared-reports.module';
import { BuildingScanReportComponent } from './building-scan-report/building-scan-report.component';
import { ExceptionProcessingReportComponent } from './exception-processing-report/exception-processing-report.component';
import { HandoverScanReportComponent } from './handover-scan-report/handover-scan-report.component';

@NgModule({
  declarations: [
    HandoverScanReportComponent,
    ExceptionProcessingReportComponent,
    BuildingScanReportComponent,
  ],
  imports: [
    CommonModule,
    FormsModule,
    SharedModule,
    ReactiveFormsModule,
    SharedReportsModule,
  ],
  exports: [],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class ExceptionsReportsModule {}
